var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#9989f9",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-0.01628) scale(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345,4346c-84,-21 -147,-57 -211,-121c-65,-65 -105,-136 -123,-223c-16,-76 -16,-2810 0,-2884c37,-171 177,-311 347,-347c75,-16 4329,-16 4404,0c170,36 311,178 347,347c16,76 16,2810 0,2884c-37,172 -176,311 -347,347c-81,17 -4349,14 -4417,-3zM3635,3089c-534,-533 -982,-977 -997,-985c-35,-18 -121,-18 -156,0c-15,8 -463,452 -997,985l-970,971h2045h2045zM947,1913l-647,-648v1295v1295l647,-648l648,-647zM4820,2558v-1293l-647,647l-648,648l645,645c355,355 646,645 647,645c2,0 3,-582 3,-1292zM2039,2107c215,-213 243,-237 315,-273l80,-39h125c125,0 127,0 205,38c73,35 96,55 318,274l239,237l642,-642l642,-642h-2045h-2045l640,640c352,352 642,640 644,640c3,0 111,-105 240,-233z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0304dd63eead59771bf5a77e49aedd7e.svg";
export { ForwardRef as ReactComponent };